import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'medsurf-design-content-card',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './card.content.design.html',
    styleUrls: ['./card.content.design.scss'],
    standalone: false
})
export class CardContentDesign {
  @Input({ required: true }) titleText!: string;
}
